import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';

import "./styles/multipliers-styles.scss"
import { Link } from 'react-router-dom';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function Multipliers(props) {
    // props
    const { history } = props

    // store url
    const [storeUrl] = useStoreUrl()

    // consts
    const MULTIPLIER = [
        { icon: "slash", heading: "Store Multiplier", class: "app-multipliers-card-white", href: "store" },
        // { icon: "slash", heading: "Brand Multiplier", class: "app-multipliers-card-light", href: "brand" },
        { icon: "slash", heading: "Brand Multiplier", class: "app-multipliers-card-white", href: "brand" },
        { icon: "slash", heading: "Category Multiplier", class: "app-multipliers-card-white", href: "category" },
        { icon: "package", heading: "Product Multiplier", class: "app-multipliers-card-white", href: "product" },
        { icon: "package", heading: "Shipping Multiplier", class: "app-multipliers-card-white", href: "shipping" },
    ]

    return (
        <section id="app-multipliers" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Multipliers</p>
                        <p className="app-desc">Setup  of Multipliers</p>
                    </div>

                    <div className="app-content-container">
                        {
                            MULTIPLIER.map((e, index) => (
                                <Col lg={9} md={12} key={index}>
                                    <div className="app-card mb-3" key={index}>
                                        <div className={`app-card-content border st-default-rounded-block cursor-pointer ${e.class}`} onClick={() => history.push(`${storeUrl}/catalog/multipliers/${e.href}`)}>
                                            <div className="pad-15">
                                                <div className="cats-all-btns justify-content-between d-flex ">
                                                    <div className="cats-all-btns-inner d-flex flex-wrap  align-items-center">
                                                        <span className="pad-12 app-multipliers-icon me-3">
                                                            <FeatherIcon
                                                                icon={e.icon}
                                                                size="40"
                                                                className="icon text-primary" 
                                                            />
                                                        </span>

                                                        <div className="app-header-wrapper heading-md d-flex flex-column justify-content-start mb-0">
                                                            <p className="text-capitalize st-fs-20 text-dark2 app-multiplier-heading mb-1">{e.heading}</p>
                                                            <p className="text-capitalize app-multiplier-desc">manage the settings for <span>{e.heading}</span></p>
                                                        </div>
                                                    </div>
                                                    <div className="cats-all-btns-inner d-flex flex-wrap align-items-center ">
                                                        <Link
                                                            to={`${storeUrl}/catalog/multipliers/${e.href}`}
                                                            className="st-btn st-btn-primary st-btn-sm no-min-width d-flex align-items-center justify-content-center me-2 pad-25-L pad-R-25 setup-btn">
                                                            Setup
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                        {/* <div className="app-card ">
                            <div className="app-card-content bg-white border st-default-rounded-block mb-3">
                                <div className="acc_top-bar ">
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </Container>
        </section >
    )
}


const getDataFromStore = state => {
    return {
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Multipliers)